/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DirectorDocumentDTO } from "./DirectorDocumentDTO";

/**
 * List of company directors
 */
export type DirectorDetailsDTO = {
  /**
   * Bank Verification Number
   */
  bankVerificationNumber?: string;
  /**
   * Director's date of birth
   */
  dateOfBirth?: string;
  /**
   * List of director's identification documents
   */
  documents?: Array<DirectorDocumentDTO>;
  /**
   * Whether the director is a foreigner
   */
  isForeigner?: boolean;
  /**
   * Full name of the director
   */
  name?: string;
  /**
   * National Identification Number
   */
  nationalIdentificationNumber?: string;
  /**
   * Verification status of this director
   */
  verificationStatus?: DirectorDetailsDTO.verificationStatus;
};

export namespace DirectorDetailsDTO {
  /**
   * Verification status of this director
   */
  export enum verificationStatus {
    PENDING = "PENDING",
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
  }
}
